import React from "react";
import { cn } from "./cn";

/** Surface container that adapts to dark mode. */
export const Card = ({ className, children, ...rest }) => (
  <div
    className={cn(
      "bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-2xl shadow-sm",
      className
    )}
    {...rest}
  >
    {children}
  </div>
);

export const CardHeader = ({ className, children, ...rest }) => (
  <div className={cn("px-6 py-4 border-b border-gray-100 dark:border-gray-700", className)} {...rest}>
    {children}
  </div>
);

export const CardBody = ({ className, children, ...rest }) => (
  <div className={cn("p-6", className)} {...rest}>
    {children}
  </div>
);

export const CardFooter = ({ className, children, ...rest }) => (
  <div className={cn("px-6 py-4 border-t border-gray-100 dark:border-gray-700", className)} {...rest}>
    {children}
  </div>
);

export default Card;
